// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Regex from "../../../../utils/Regex.bs.js";
import * as React from "react";
import * as NextButton from "../../../library/NextButton.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as FormHelpers from "../../../../utils/FormHelpers.bs.js";
import * as ReactHookForm from "../../../../bindings/ReactHookForm.bs.js";
import * as PreviousButton from "../../../library/PreviousButton.bs.js";
import * as SignUpStepStyles from "./SignUpStepStyles.bs.js";
import * as LayoutDataContext from "../../../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RichText$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js";
import * as TextField$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js";

var make = React.memo(function (props) {
      var dispatch = props.dispatch;
      var onNextBtnClick = props.onNextBtnClick;
      var onPreviousBtnClick = props.onPreviousBtnClick;
      var layoutData = LayoutDataContext.useContext(undefined);
      var registerData = Belt_Option.flatMap(layoutData, (function (o) {
              return o.register;
            }));
      var userName = FormHelpers.getValue(props.stateFirstName);
      var stepTitleEmail = Belt_Option.mapWithDefault(registerData, "<p>Hi " + (userName + ",</p><p>Please enter your email</p>"), (function (c) {
              return c.stepTitleEmail.replace("{0}", userName);
            }));
      var emailLabel = Belt_Option.mapWithDefault(registerData, "Email", (function (c) {
              return c.emailLabel;
            }));
      var emailRequiredText = Belt_Option.mapWithDefault(registerData, "Your email is required", (function (c) {
              return c.emailRequiredText;
            }));
      var invalidEmailText = Belt_Option.mapWithDefault(registerData, "Please enter a valid email address", (function (c) {
              return c.invalidEmailText;
            }));
      var emailInput = {
        required: {
          value: true,
          message: emailRequiredText
        },
        pattern: {
          value: Regex.emailRegex,
          message: invalidEmailText
        }
      };
      var form = ReactHookForm.useForm({
            mode: "all",
            defaultValues: {
              email: props.stateEmail
            }
          }, undefined);
      var onSubmit = React.useCallback((function (data) {
              var email = FormHelpers.getValue(data.email);
              if (email !== "") {
                Curry._1(dispatch, {
                      TAG: /* Step2Update */1,
                      email: email
                    });
              }
              Curry._1(onNextBtnClick, undefined);
            }), [dispatch]);
      return JsxRuntime.jsxs("form", {
                  children: [
                    JsxRuntime.jsx("label", {
                          children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                children: stepTitleEmail
                              }),
                          className: SignUpStepStyles.formLabel
                        }),
                    JsxRuntime.jsx(TextField$PrezzeeRibbon.make, {
                          autoComplete: "off",
                          autoFocus: true,
                          className: SignUpStepStyles.formInput_,
                          label: emailLabel,
                          name: "email",
                          type_: "email",
                          error: Belt_Option.isSome(FormHelpers.getError(form.formState.touched, "email", form.errors)),
                          helperText: Belt_Option.getWithDefault(FormHelpers.getError(form.formState.touched, "email", form.errors), ""),
                          inputRef: Caml_option.some(Curry._1(form.register, emailInput))
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(PreviousButton.make, {
                                  onClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* Step2Update */1,
                                            email: FormHelpers.getValue(Curry._1(form.getValues, undefined).email)
                                          });
                                      Curry._1(onPreviousBtnClick, undefined);
                                    }),
                                  className: SignUpStepStyles.previousButton
                                }),
                            JsxRuntime.jsx(NextButton.make, {
                                  className: form.formState.isValid ? SignUpStepStyles.nextButton : SignUpStepStyles.nextButtonDisabled,
                                  isDisabled: !form.formState.isValid,
                                  type_: "submit"
                                })
                          ],
                          className: "flex items-center justify-between"
                        })
                  ],
                  onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                });
    });

export {
  make ,
}
/* make Not a pure module */
